import React from 'react'
export default () => (
  <svg viewBox="0 0 24 24">
    <path d="M12.27,17.55,9.67,15l2.19-2.2a.67.67,0,0,0,0-.93l-2-2,1.74-4.35a.7.7,0,0,0-.08-.64,6,6,0,0,0-4.87-2.5c-3.51,0-6,2.76-6,6.69a7.5,7.5,0,0,0,.45,2.64c1,2.71,3.45,4.8,6.81,7.63.76.63,1.57,1.32,2.42,2.05.31.27.51.51.92.38a.65.65,0,0,0,.44-.47l.76-3A.74.74,0,0,0,12.27,17.55Z" />
    <path d="M17.33,2.29a5.93,5.93,0,0,0-3.28,1,.74.74,0,0,0-.27.31L11.59,9.18a.68.68,0,0,0,.14.73l2.54,2.57-2.21,2.24a.68.68,0,0,0,0,.95l2,2-.67,2.74a.69.69,0,0,0,.3.75c.37.23.65.06.93-.2,1.95-1.7,3.49-3.05,4.84-4.36a13,13,0,0,0,3.44-4.84,8.24,8.24,0,0,0,.46-2.69c0-4-2.48-6.82-6-6.82Z" />
  </svg>
)
